import { TextKey, RouteName } from '@mews-commander/enums';
import { useLocalizeText } from '@mews/framework';
import { UnicodeEntity } from '@mews/enums';
import { isCurrentProfileAdmin } from '@mews-commander/legacy-entities/src/selectors/session/scope';
import { useCommanderSelector } from '@mews-commander/utils';
import { useNavigationSearchResult } from './useNavigationSearchResult';
import { AssistantNavigation } from './AssistantNavigation';
import { useNavigationPath } from './useNavigationPath';

export const useQueuesNavigation = (): AssistantNavigation[] => {
    const localizeText = useLocalizeText();

    const parentPath = `${localizeText({ textKey: TextKey.QueuePlural })}${UnicodeEntity.Space}${
        UnicodeEntity.ForwardSlash
    }${UnicodeEntity.Space}`;

    const channelManagerQueueItem = useNavigationSearchResult(
        RouteName.ChannelManagerQueueItemIndex,
        TextKey.ChannelManager,
        {},
        useNavigationPath(parentPath, TextKey.ChannelManager)
    );
    const exportQueue = useNavigationSearchResult(
        RouteName.ExportQueue,
        TextKey.ExportPlural,
        {},
        useNavigationPath(parentPath, TextKey.ExportPlural)
    );
    const mailQueueItem = useNavigationSearchResult(
        RouteName.MailQueueItemIndex,
        TextKey.MailPlural,
        {},
        useNavigationPath(parentPath, TextKey.MailPlural)
    );
    const installationQueueItem = useNavigationSearchResult(
        RouteName.InstallationQueueItemIndex,
        TextKey.InstallationPlural,
        {},
        useNavigationPath(parentPath, TextKey.InstallationPlural)
    );
    const inventoryUpdate = useNavigationSearchResult(
        RouteName.InventoryUpdateIndex,
        TextKey.InventoryUpdatePlural,
        {},
        useNavigationPath(parentPath, TextKey.InventoryUpdatePlural)
    );
    const deviceCommand = useNavigationSearchResult(
        RouteName.DeviceCommandIndex,
        TextKey.DeviceCommandPlural,
        {},
        useNavigationPath(parentPath, TextKey.DeviceCommandPlural)
    );

    const adminQueueResults = useCommanderSelector<boolean>(isCurrentProfileAdmin)
        ? [channelManagerQueueItem, exportQueue, mailQueueItem, installationQueueItem, inventoryUpdate]
        : [];

    return [deviceCommand, ...adminQueueResults];
};
